import React, { useCallback, useState } from 'react';

import FilterDrawerActions from '../filters/FilterDrawerActions';
import FilterDockButton from './FilterDockButton';
import FilterDrawer from './FilterDrawer';

export interface FilterDockProps {
  title?: string;
  /** Si se define, se muestra el botón "Buscar" al final del drawer y se cierra al buscar */
  onSearch?: () => void | Promise<void>;
  children?: React.ReactNode;
}

const FilterDock: React.FC<FilterDockProps> = ({
  title = 'Filtros',
  onSearch,
  children,
}) => {
  const [open, setOpen] = useState(false);

  const handleSearch = useCallback(async () => {
    await onSearch?.();
    setOpen(false);
  }, [onSearch]);

  return (
    <>
      <FilterDockButton onClick={() => setOpen(true)} />
      <FilterDrawer open={open} onClose={() => setOpen(false)} title={title}>
        {children}
        {onSearch != null ? (
          <FilterDrawerActions onSearch={handleSearch} />
        ) : null}
      </FilterDrawer>
    </>
  );
};

export default FilterDock;
